import { useEffect, useState } from 'react';
import { useImageCutoutHelper } from '@/hooks/use-image-cutout-helper';
import { editor } from '@/instance';
import { useStoreState } from '@/store';

const useShowLayerWaterMark = () => {
    const [showWaterMark, setShowWaterMark] = useState(false);
    const { isRenderWatermark, finalWatermarkData } = useStoreState((state) => state.svipWatermarkModel);

    const activeStageIndex = editor.active.getActiveStageIndex();

    const activeLayer = editor.active.getPick(true);
    const customParams = useStoreState((state) => state.sdkModel.customParams);

    const { isImageCutout } = useImageCutoutHelper();

    useEffect(() => {
        if (!isRenderWatermark && isImageCutout && !customParams.removeFree && activeLayer) {
            setShowWaterMark(true);
            return;
        }
        if (!isRenderWatermark) {
            setShowWaterMark(false);
            return;
        }
        const activeIndex = activeStageIndex;
        const watermarkInfo = finalWatermarkData.get(activeIndex);
        if (!watermarkInfo) {
            setShowWaterMark(false);
            return;
        }
        const { watermarkLayers, isGlobal } = watermarkInfo;
        if (isGlobal) {
            setShowWaterMark(true);
            return;
        }
        if (!watermarkLayers?.length && isImageCutout && activeLayer) {
            setShowWaterMark(true);
            return;
        }
        if (!watermarkLayers?.length) {
            setShowWaterMark(false);
            return;
        }
        setShowWaterMark(true);
    }, [activeLayer, activeStageIndex, customParams.removeFree, finalWatermarkData, isImageCutout, isRenderWatermark]);
    return showWaterMark;
};

export default useShowLayerWaterMark;
